import { useEffect } from "react";
import { rimStyles, rimColors } from "./data/config";
import NameSelector from "./NameSelector";

const Rims = ({ selectedColor, selectedRimStyle, selectRimStyle, selectedRimColor, selectRimColor }) => {

    useEffect(() => {
        if(selectedRimStyle.colors.indexOf(selectedRimColor.id) === -1) {
            selectRimColor(selectedRimStyle.colors[0]);
        }
    }, [selectedRimStyle, selectedColor, selectRimColor, selectedRimColor])

    const handleClick = (rimStyle) => () => {
        selectRimColor(rimColors[rimStyle.colors[0]]);
        selectRimStyle(rimStyle);
    }

    return <div className="space-y-4">
        <div>
            <h2 className="section-title">Wheels</h2>
            <h3 className="subsection-title">Style</h3>
            <h3 className="selection-title">{selectedRimStyle.name}</h3>
            <div className="flex">
                {rimStyles.map(rimStyle => {
                    return <div key={rimStyle.name} className={`${rimStyle.id === selectedRimStyle.id && 'bg-tan-300'} hover:bg-gray-200 rounded-md flex items-center justify-center p-1 m-1 text-white cursor-pointer duration-300`} onClick={handleClick(rimStyle)}>
                        <img src={`./images/Rim_Icons/TATC_Config_Rim_Icon_${rimStyle.prefix}_Black_Solid.png`} alt={rimStyle.name} />
                    </div>
                })}
            </div>
        </div>
        <div>
            <h2 className="subsection-title">Colour</h2>
                <div>
                    <h3 className="selection-title">{selectedRimColor.name}</h3>
                    <div className="grid grid-cols-3 gap-4">
                        {selectedRimStyle.colors?.map(rimStyleColor => {
                            const rc = rimColors[rimStyleColor];
                            return <NameSelector
                                name={rimColors[rimStyleColor].name}
                                key={rc.id}
                                onClick={() => selectRimColor(rc)}
                                selected={selectedRimColor.id === rc.id}
                            ></NameSelector>
                        })}
                    </div>
                </div> 
               
        </div>
    </div>
}

export default Rims;